import { makeStyles } from "@material-ui/core";
export default makeStyles(() => ({
  appBar: {
    backgroundColor: "transparent",
  },
  alignGridItems: {
    display: "flex",
    justifyContent: "flex-end",
    "& a": {
      width: "fit-content",
      margin: [["auto", 10]],
    },
  },
}));
